import { apiClient } from '@/api/client';
import type { FeedbackSubmissionResponse } from '@/api/types';
import { transactionPageUrl } from '@/utils/transactions/transactionUrl';

export async function submitFeedback(
  feedbackText: string,
  screenshot?: File | null,
  transactionId?: string | null,
  includeSourceDocument?: boolean
): Promise<FeedbackSubmissionResponse> {
  const formData = new FormData();
  formData.append('FeedbackText', feedbackText);

  if (screenshot) {
    formData.append('Screenshot', screenshot);
  }

  if (transactionId) {
    formData.append('TransactionId', transactionId);
    formData.append('TransactionUrl', transactionPageUrl(transactionId));
  }

  formData.append('IncludeSourceDocument', String(!!includeSourceDocument));

  const { data } = await apiClient.post('/api/v1/support/feedback', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return data;
}
